/* eslint-disable babel/no-unused-expressions */
/* SLIDE UP */
const slideUp = (target, duration = 500) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.boxSizing = 'border-box';
  target.style.height = `${target.offsetHeight}px`;
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

/* SLIDE DOWN */
const slideDown = (target, duration = 500) => {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.height = `${height}px`;
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

/* TOOGLE */
const slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
};

const accordions = () => {
  const $accordions = document.querySelectorAll('.accordion');

  $accordions.forEach((accordion) => {
    const $triggers = accordion.querySelectorAll('.accordion__trigger');
    const $panels = accordion.querySelectorAll('.accordion__panel');

    const handleClick = (event) => {
      // find the current trigger
      const $trigger = event.target.closest('.accordion__trigger');

      // if we hanen't clicked on a trigger return
      if (!$trigger) {
        return;
      }

      // find the current panel
      const panelId = $trigger.getAttribute('aria-controls');
      const $panel = accordion.querySelector(`#${panelId}`);
      const multiplePanes = $trigger.getAttribute('aria-multi');
      const slideDuration = 200;

      if (multiplePanes !== '1') {
        // hide all panels
        $triggers.forEach((trigger) => {
          if (trigger !== $trigger) {
            trigger.setAttribute('aria-expanded', false);
          }
        });
        $panels.forEach((panel) => {
          if (panel === $panel) {
            const ariaState = $trigger.getAttribute('aria-expanded');
            if (ariaState === 'true') {
              $trigger.setAttribute('aria-expanded', false);
            } else {
              $trigger.setAttribute('aria-expanded', true);
            }
            slideToggle(panel, slideDuration);
          } else {
            slideUp(panel, slideDuration);
          }
        });
      } else if (multiplePanes === '1') {
        if ($trigger.getAttribute('aria-expanded') === 'true') {
          $trigger.setAttribute('aria-expanded', false);
          slideUp($panel, slideDuration);
        } else {
          $trigger.setAttribute('aria-expanded', true);
          slideDown($panel, slideDuration);
        }
      }
    };

    // attach event listener to the accordion itself
    accordion.addEventListener('click', handleClick);
  });
};

export default accordions;
